import { useVirtualizerScrollView_unstable } from './useVirtualizerScrollView';
import { renderVirtualizerScrollView_unstable } from './renderVirtualizerScrollView';
import { useVirtualizerScrollViewStyles_unstable } from './useVirtualizerScrollViewStyles.styles';
import { useCustomStyleHook_unstable } from '@fluentui/react-shared-contexts';
/**
 * Virtualizer ScrollView
 */ export const VirtualizerScrollView = (props)=>{
    const state = useVirtualizerScrollView_unstable(props);
    useVirtualizerScrollViewStyles_unstable(state);
    useCustomStyleHook_unstable('useVirtualizerScrollViewStyles_unstable')(state);
    return renderVirtualizerScrollView_unstable(state);
};
VirtualizerScrollView.displayName = 'VirtualizerScrollView';

//# sourceMappingURL=VirtualizerScrollView.js.map